import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-143b6496"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "ap-table",
  ref: "tableBody"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ap_loader = _resolveComponent("ap-loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.hasHeader)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["ap-table-row ap-table-header", _ctx.headerClass])
          }, [
            _renderSlot(_ctx.$slots, "header", {}, undefined, true)
          ], 2))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["ap-table-row ap-table-content", _ctx.rowClassInner(row)]),
          key: _ctx.keySelector(row)
        }, [
          _renderSlot(_ctx.$slots, "default", { row: row }, undefined, true)
        ], 2))
      }), 128))
    ], 512),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_ap_loader, {
          key: 0,
          class: "lg"
        }))
      : _createCommentVNode("", true)
  ], 64))
}